const required = { required: true, message: 'This is a required field.' }
const requiredRule = [required]

const textAreaRule = {
  validator: (_: any, val: string) => {
    if (!val) {
      return Promise.resolve()
    }

    if (val.match(/<\/?[^>]+(>|$)/g)?.length) {
      return Promise.reject('HTML tags are not allowed')
    }

    if (val.length < 20) {
      return Promise.reject('Minimum character 20')
    }

    return Promise.resolve()
  }
}

export { requiredRule, textAreaRule }
